import { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import {
  CalendarIcon,
  DashboadIcon,
  FinanceReportIcon,
  PatientListIcon,
  ReferralIcon,
  SalesforceIcon
} from 'assets/icons';
import InboxNav from 'components/Navbar/InboxNav/InboxNav';
import { pagePaths } from 'config/pages';
import { PERMISSIONS } from 'constants/Permissions';
import { useRevenueReportAccess } from 'pages/FinanceReport/Revenue/useRevenueReportAccess';
import { loginedUserDetails } from 'store/atoms';
import { NavItem } from 'types/Navbar';
import { useHasAccess } from 'utils/hasAccess';

const useNavBarConfig = () => {
  const loginedUser = useRecoilValue(loginedUserDetails);

  const isSoaEnabled = useMemo(() => {
    return loginedUser?.clinic?.some((clinic) => clinic.isSOAEnabled);
  }, [loginedUser]);
  const showSoa = useHasAccess(PERMISSIONS.FINANCE_TAB_VIEW) && isSoaEnabled;
  const showRevenue = useRevenueReportAccess().canView;

  const getNavBarItems = () => {
    const navBarItems: Array<NavItem> = [
      {
        title: 'dashboard_button.dashboard',
        icon: DashboadIcon,
        path: pagePaths.dashboard,
        permission: PERMISSIONS?.DASHBOARD_PAGE,
        testId: 'sidebar-item-dashboard'
      },
      {
        title: 'patient_list_button.patient_list',
        icon: PatientListIcon,
        path: pagePaths.patientList,
        permission: PERMISSIONS?.PATIENT_LIST,
        testId: 'sidebar-item-patients-list'
      },
      {
        title: 'calendar_button.calendar',
        icon: CalendarIcon,
        path: pagePaths.calendar,
        permission: PERMISSIONS?.CALENDAR,
        testId: 'sidebar-item-calendar'
      },
      {
        title: <InboxNav />,
        path: pagePaths.inbox,
        permission: PERMISSIONS?.INBOX,
        testId: 'sidebar-item-inbox'
      },
      {
        title: 'referrals.referrals',
        icon: ReferralIcon,
        path: pagePaths.referrals,
        permission: PERMISSIONS?.REFERRAL,
        testId: 'sidebar-item-referrals'
      },
      {
        title: 'finance_report_button.finance_report',
        icon: FinanceReportIcon,
        path: pagePaths.financeReport,
        testId: 'finance',
        // Each entry has its own permission; the group shows if either does.
        hidden: !showSoa && !showRevenue,
        children: [
          {
            title: 'finance_navigation.revenue',
            path: pagePaths.financeRevenue,
            testId: 'sidebar-item-revenue',
            hidden: !showRevenue
          },
          {
            title: 'finance_navigation.soa',
            path: pagePaths.financeSOA,
            permission: PERMISSIONS?.FINANCE_TAB_VIEW,
            testId: 'sidebar-item-soa',
            hidden: !showSoa
          }
        ]
      },
      {
        title: 'salesforce_button.salesforce',
        icon: SalesforceIcon,
        path: pagePaths.salesforce,
        permission: PERMISSIONS?.SALESFORCE,
        testId: 'sidebar-item-salesforce',
        hidden: !loginedUser?.details?.crmUserId
      }
    ];
    return navBarItems;
  };
  return { getNavBarItems };
};
export default useNavBarConfig;
